/*!
 * @Author: luoob
 * @Date: 2021-11-08 11:14:32
 * @Last Modified by: luoob
 * @Last Modified time: 2021-11-08 11:14:35
 * @Introduction: 发布会模块路由
 */

/* Layout */
import Layout from '@/layout/index.vue'

const ReleaseList = () => import('@/views/release/list.vue')
const ReleaseDetail = () => import('@/views/release/detail.vue')

export default {
    path: '/release',
    component: Layout,
    redirect: '/release/list',
    children: [
        {
            path: 'list',
            component: ReleaseList,
            name: 'ReleaseList',
            meta: {
                title: '发布会',
                icon: 'icon-huiyi'
            }
        },
        {
            path: ':id',
            component: ReleaseDetail,
            name: 'ReleaseDetail',
            meta: {
                title: '发布会详情',
                hidden: true
            }
        }
    ]
}
